import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component Grouped.
 * @component
 * @param {Object} props - Component Properties
 * @param {string} props.namespace - Prefix for CSS classes
 * @param {string} props.container - Name of the container for CSS classes
 * @param {React.ReactNode} [props.children] - Child components to render inside the container
 * @param {Object} [props.rest] - Additional properties that will be passed to the div element
 * @returns {JSX.Element} Grouped Component with its children
 */

const GroupedComponent = ({ namespace, container, children, ...props }) => (
  <div className={`${namespace}__${container}`} {...props}>
    {children}
  </div>
);

GroupedComponent.propTypes = {
  children: PropTypes.node,
  container: PropTypes.string.isRequired,
  namespace: PropTypes.string.isRequired,
};

export default GroupedComponent;
